exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pip-link{color:#367c2b;font-size:1.4rem;font-weight:700}.cf .pip-link,.hitachi .pip-link{color:#333}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/pip/shared/components/pip-link.scss
// module id = 5095
// module chunks = 0